import { render, staticRenderFns } from "./TenancyTenant.vue?vue&type=template&id=46d3d1bb&scoped=true&"
import script from "./TenancyTenant.vue?vue&type=script&lang=js&"
export * from "./TenancyTenant.vue?vue&type=script&lang=js&"
import style0 from "./TenancyTenant.vue?vue&type=style&index=0&id=46d3d1bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d3d1bb",
  null
  
)

export default component.exports